const pricing = {
  title: "プランと価格",
  pricing: "PRICING",
  description: "Tenak AIのプランと価格",
  legalNotice: "特定商取引法に基づく表記",
  free: {
    title: "Free",
    description: "無料プラン",
    price: "0",
    credit: "50",
  },
  basic: {
    title: "Basic",
    description: "ベーシックプラン",
    price: "18",
    credit: "900",
  },
  standard: {
    title: "Standard",
    description: "スタンダードプラン",
    price: "36",
    credit: "1,800 + 200",
  },
  premium: {
    title: "Premium",
    description: "プレミアムプラン",
    price: "72",
    credit: "3,600 + 600",
  },
  perMonth: "月額",
  credit: "クレジット",
  firstTimeOnly: "（初回のみ）",
  dailyCredit: "クレジット（デイリーボーナス）",
  aiEngine: "パワフルAIエンジン",
  juno: "STUDIO JUNO（画像生成）",
  junoPrivate: "生成画像の非公開設定",
  junoEngine: "全ての画像生成AIエンジン",
  junoEnginePart: "一部の画像生成AIエンジン",
  junoVideo: "STUDIO JUNO（動画生成）",
  junoSimultaneousLimit: "STUDIO JUNO 同時生成数の上限",
  mindmap: "マインドマップ生成",
  export: "マインドマップのエクスポート",
  template: "全てのAIテンプレート",
  textEditor: "AIテキストエディター",
  voice: "音声生成",
  additionalCredits: "追加クレジットの購入",
  support: "サポート",
  supportPriority: "優先サポート",
  supportNo: "サポートなし",
  subscribe: "購入する",
  aboutCredit: {
    title: "クレジットについて",
    description:
      "Tenak AIのプランは、クレジット制を採用しています。クレジットは、文字、画像、音声生成などのAI機能を利用するための通貨です。デイリーボーナスは繰り越されません。以下に目安の消費クレジットを記載しています。",
    text: {
      title: "テキスト生成",
      "openai-gpt4.1-input": "知能優先モデル（入力）（GPT-4.1）",
      "openai-gpt4.1-output": "知能優先モデル（出力）（GPT-4.1）",
      "openai-gpt4.1-mini-input": "速度優先モデル（入力）（GPT-4.1-mini）",
      "openai-gpt4.1-mini-output": "速度優先モデル（出力）（GPT-4.1-mini）",
      "openai-o4-mini-input": "推論モデル（入力）（o4-mini）",
      "openai-o4-mini-output": "推論モデル（出力・推論トークン）（o4-mini）",
      note: "NOTE: テキスト生成はリサーチ時やWeb検索時、またシステムプロンプト、推論処理等、内部で使用されたトークン加算されます",
    },
    image: {
      title: "画像生成",
      "openai-dalle3-hd": "OPEN AI: DALL-E 3",
      "openai-gpt-image-1-high": "OPEN AI: GPT Image 1 (High)",
      "openai-gpt-image-1-medium": "OPEN AI: GPT Image 1 (Medium)",
      "openai-gpt-image-1-low": "OPEN AI: GPT Image 1 (Low)",
      sdapi: "Stable Diffusion (XL)",
      sd3: "Stable Diffusion 3.5",
      "sd-ultra": "Stable Image Ultra",
      "flux11-pro-ultra": "Flux 1.1 Pro Ultra",
      "flux11-pro-ultra-juno": "Flux 1.1 Pro Ultra JUNO",
      "flux11-pro-ultra-redux": "Flux 1.1 Pro Ultra Redux",
      "flux11-pro": "Flux 1.1 Pro",
      "flux1-pro": "Flux 1 Pro",
      "flux1-pro-juno": "Flux 1 Pro JUNO",
      "flux1-pro-fill": "Flux.1 Pro Fill",
      "flux1-pro-fill-juno": "Flux.1 Pro Fill JUNO",
      "flux11-pro-redux": "Flux 1 Pro Redux",
      "flux1-pro-canny": "Flux 1 Pro Canny",
      "flux1-pro-canny-juno": "Flux 1 Pro Canny JUNO",
      "flux1-pro-depth": "Flux 1 Pro Depth",
      "flux1-pro-depth-juno": "Flux 1 Pro Depth JUNO",
      "flux1-dev": "Flux.1 Dev",
      "flux1-dev-redux": "Flux 1 Dev Redux",
      "flux1-dev-fill": "Flux.1 Dev Fill",
      "flux1-dev-canny-lora": "Flux 1 Dev Canny",
      "flux1-dev-depth-lora": "Flux 1 Dev Depth",
      "flux1-schnell": "Flux.1 Schnell",
      "flux1-schnell-redux": "Flux 1 Schnell Redux",
      "flux1-realism-lora": "Flux.1 with Realism LoRA",
      "flux-juno": "Flux.1 Dev JUNO",
      "flux-palid": "Flux PuLID",
      "recraft-v3": "Recraft V3",
      "kolors-vto": "Kolors Vitrual Try-On",
      "lumina-v2": "Lumina Image v2",
      "ideogram-v3-turbo": "Ideogram V3 (Turbo)",
      "ideogram-v3-balanced": "Ideogram V3 (Balanced)",
      "ideogram-v3-quality": "Ideogram V3 (Quality)",
      imagen3: "Imagen 3",
      "imagen3-fast": "Imagen 3 Fast",
      "instant-character": "Instant Character",
      "minimax-image": "Minimax Image",
      "flux-juggernaut-base": "Juggernaut Flux Base",
      "flux-juggernaut-lightning": "Juggernaut Flux Lightning",
      "flux-juggernaut-pro": "Juggernaut Flux Pro",
      "flux-juggernaut-juno": "Juggernaut Flux Juno",
      "fal-aura-sr": "Upscaler AuraSR",
      "fal-clarity-upscaler": "Upscaler Clarity Upscaler",
      "fal-creative-upscaler": "Upscaler Creative Upscaler",
      "fal-recraft-creative-upscaler": "Recraft Creative Upscaler",
      "fal-recraft-clarity-upscaler": "Recraft Clarity Upscaler",
      "gemini-flash-edit": "Gemini Flash Edit",
      ghiblify: "Ghiblify",
      "sana-sprint": "Sana Sprint",
      "sana-48b": "Sana V1.5 4.8B",
    },
    video: {
      title: "動画生成",
      "runway-gen3a-turbo": "Runway Gen3 Alpha Turbo",
      "runway-gen4-turbo": "Runway Gen4 Turbo",
      "fal-kling-v1.0-standard": "Kling v1.0 Standard",
      "fal-kling-v1.6-standard": "Kling v1.6 Standard",
      "fal-kling-v1.0-pro": "Kling v1.0 Pro",
      "fal-kling-v1.5-pro": "Kling v1.5 Pro",
      "fal-kling-v1.6-pro": "Kling v1.6 Pro",
      "fal-kling-v2-master": "Kling v2.0 Master",
      "luma-v1.5": "v1.5",
      "luma-v1.6": "RAY 1.6",
      "luma-ray2": "RAY 2",
      "luma-ray2-1080p": "RAY 2 1080P",
      "luma-ray2-4k": "RAY 2 4K",
      "luma-ray2-flash": "RAY 2 Flash",
      "luma-ray2-flash-1080p": "RAY 2 Flash 1080P",
      "luma-ray2-flash-4k": "RAY 2 Flash 4K",
      "fal-hailuo-mini-max": "Hailuo AI",
      "fal-haiper-v2.0": "Haiper v2.0",
      "fal-haiper-v2.5": "Haiper v2.5",
      "fal-pixverse-v3.5-720p": "PixVerse v3.5",
      "fal-pixverse-v3.5-1080p": "PixVerse v3.5 1080p",
      "fal-pixverse-v3.5-fast-720p": "PixVerse v3.5 Performance",
      "fal-pixverse-v3.5-transition-720p": "PixVerse v3.5 Transition",
      "fal-pixverse-v3.5-transition-1080p": "PixVerse v3.5 Transition 1080P",
      "fal-pixverse-v4-720p": "PixVerse v4",
      "fal-pixverse-v4-1080p": "PixVerse v4 1080P",
      "fal-pixverse-v4-fast-720p": "PixVerse v4 Performance",
      "vidu-2.0-720p": "Vidu 2.0 720p",
      "vidu-2.0-1080p": "Vidu 2.0 1080p",
      "vidu-2.0-ref-720p": "Vidu 2.0 Reference",
      "fal-bytedance-latentsync": "ByteDance LatentSync",
      "fal-sync-lipsync-19": "Sync Lipsync 1.9.0",
      "fal-sync-lipsync-v2": "Sync Lipsync v2",
      "google-veo2": "Google VEO2",
      "fal-wan": "Wan v2.1",
      "fal-wan-flf2v": "Wan First to Last 720P",
      "fal-wan-pro": "Wan Pro v2.1",
      "fal-pika-v2.2-720p": "Pika v2.2 720P",
      "fal-pika-v2.2-1080p": "Pika v2.2 1080P",
      "fal-pika-v2.2-scenes-720p": "Pika v2.2 Scenes 720P",
      "fal-pika-v2.2-scenes-1080p": "Pika v2.2 Scenes 1080P",
      "fal-pika-v2-turbo-720p": "Pika v2 Turbo 720P",
      "fal-pika-v2-pikaswaps": "Pika Swaps V2",
      "fal-pika-v2-pikadditions": "Pika Additions V2",
      "fal-real-esrgan": "RealESRGAN Video Upscaler",
      "fal-topaz-video-upscale": "Topaz Video Upscale",
      "fal-framepack": "FramePack",
    },
    voice: {
      title: "音声生成",
      "google-tts": "Google TTS（1,000文字）",
      "gpt-4o-mini-tts": "OPEN AI TTS (1,000 tokens)",
    },
    sound: {
      title: "サウンド生成",
      "fal-cassetteai-music": "CassetteAI Music",
      "fal-cassetteai-sfx": "CassetteAI SFX",
      "fal-diffrhythm": "DiffRhythm",
      "fal-elevenlabs-sfx": "ElevenLabs SFX",
      "fal-minimax-music": "MiniMax Music",
      "fal-mmaudio-v2": "MM Audio v2",
    },
    mindmap: {
      title: "マインドマップ生成",
      description: "AIを使用しない場合（AIジェネレーター使用時はテキスト生成に依存）",
    },
    annotation:
      "* この表は目安であり、AIエンジンのアップデートにより予告なしに変更される可能性があります。 * 小数点第二位以下は切り上げて計算されます。",
    usageExamples: {
      title: "クレジットでできること",
      description: "各プランのクレジットで何ができるかを示します。使用するAIモデルによって範囲は異なります。",
      category: "カテゴリ",
      basic: "ベーシック（900クレジット）",
      standard: "スタンダード（2000クレジット）",
      premium: "プレミアム（4200クレジット）",
      textRange: "〜 {{max}} M tokens",
      imageRange: "〜 {{max}} 枚",
      videoRange: "〜 {{max}} 秒",
      voiceRange: "〜 {{max}} K 文字",
      note: "※ これは目安であり、特定のAIモデルやコンテンツによって異なる場合があります。",
    },
  },
  tabs: {
    subscriptionPlans: "サブスクリプションプラン",
    businessPlans: "エンタープライズプラン",
    permanentCredits: "無期限の追加クレジット",
  },
  permanentCredit: {
    title: "追加クレジット",
    description:
      "スタンダードプラン以上のユーザーは、期限なしで使えるクレジットを購入できます。\n通常のクレジットより費用はかかりますが、いつでも安心して利用できます。",
    credits: "クレジット",
    unitPrice: "単価",
    neverExpire: "期限なし",
    purchase: "購入する",
    upgradeRequired: "追加クレジットの購入にはStandard以上のプランが必要です。",
    discountRateStandard: "",
    discountRatePremium: "（割引）",
    modalTitle: "追加クレジットの購入",
    modalDescription: "追加クレジットは期限なしで使えるクレジットです。一度購入したクレジットは無期限で利用可能です。",
    modalCaution1: "追加クレジットは購入後、即時に反映されます。",
    modalCaution2: "追加クレジットは返金できません。",
    modalCaution3: "購入前に利用規約とプライバシーポリシーをご確認ください。",
    modalProduct: "商品",
    modalCredits: "クレジット数",
    modalPrice: "価格",
    forStandardUsers: "Standard プラン向け",
    forPremiumUsers: "Premium プラン向け",
  },
  enterprise: {
    title: "エンタープライズプラン",
    description: "チーム・組織向け",
    description2: "5 〜 100名のチーム向けのプラン",
    feature1: "期限なく利用できるクレジットを特別割引価格で",
    feature2: "チーム全体でクレジットをシームレスに共有",
    feature3: "専任のエンタープライズサポートへ優先アクセス",
    feature4: "組織管理のための高度な設定機能",
    contact: "お問い合わせ",
    contactDetail: "詳細やカスタマイズについてはお問い合わせください。",
  },
  faq: {
    title: "よくある質問",
    description: "Tenak AIのプランと価格に関するよくある質問",
    q1: "クレジットは繰り越せますか？",
    a1: "「無期限の追加クレジット」以外のクレジットは繰り越せません。",
    q2: "アップグレードしたら料金は日割り計算されますか？",
    a2: "いいえ。クレジット制を導入しているため、全額請求されます。そして、お持ちのクレジットと新しいプランのクレジットが合算され、その日から1ヶ月後がクレジット失効日かつ次回請求日となります。",
    q3: "クレジットだけ購入することはできますか？",
    a3: "はい。スタンダードプラン以上のユーザーは、「無期限の追加クレジット」を購入できます。",
    q4: "プランを解約した場合、クレジットはどうなりますか？",
    a4: "プランを解約した場合、その更新月でクレジットは失効します。",
    q5: "クレジットが足りなくなった場合、どうすればいいですか？",
    a5: "クレジットが足りなくなった場合、プランをアップグレードするか、追加購入してください。",
    q6: "デイリーボーナスはいつにリセットされますか？",
    a6: "最後に受け取ってから24時間以降にログインするとリセットされます。",
    q7: "プランのダウングレードはできますか？",
    a7: "いいえ。一度ご解約頂き、期間満了後に再度プランをご購入していただく必要があります。",
  },
};
export default pricing;
